import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

const Header = props => {
  return (
    <header>
      <Link to="/">
      <Img fixed={props.logo.childImageSharp.fixed} />
      </Link>
    </header>
  )
}

export default Header